import React from 'react';
import { Container } from '@mui/material';

import CalendarScreen from './CalendarScreen';
import { ScheduleHubContext, useScheduleHubViewModel } from './ScheduleHubViewModel';
import LoadingSpinner from '../../components/global/LoadingSpinner';

const ScheduleHub: React.FC = () => {
  const viewModel = useScheduleHubViewModel();
  const {
    prefetchedData,
  } = viewModel;
  const {
    employeeQuery,
    hydrateAppointmentsQuery,
    scheduleQuery,
    workHoursQuery,
    appointmentIds,
  } = prefetchedData;

  const hasEmployee = Boolean(employeeQuery.data?.id);
  const hasRenderableAppointmentData =
    appointmentIds.length === 0 ||
    hydrateAppointmentsQuery.isSuccess ||
    prefetchedData.myAppointments.length > 0;
  const isInitialAppointmentHydration =
    appointmentIds.length > 0 &&
    hydrateAppointmentsQuery.isPending &&
    !hasRenderableAppointmentData;
  const isCacheLoading =
    employeeQuery.isLoading ||
    (hasEmployee && (scheduleQuery.isLoading || workHoursQuery.isLoading)) ||
    isInitialAppointmentHydration;

  if (isCacheLoading) {
    return <LoadingSpinner />;
  }

  return (
    <ScheduleHubContext.Provider value={viewModel}>
      <Container disableGutters sx={{ px: { xs: 1, sm: 2 }, pt: 2 }}>
        <CalendarScreen />
      </Container>
    </ScheduleHubContext.Provider>
  );
};

export default ScheduleHub;
